(function() {
    angular
        .module("devicesModule")
        .controller("DeviceMessageBoardController", DeviceMessageBoardController)

    DeviceMessageBoardController.$inject = [
        "$rootScope",
        "$scope",
        "$state",
        "$stateParams",
        "$timeout",
        "imagesService",
        "devicesService",
        "messageBoardsService",
        "speedLimitTrailersService",
        "telemetryService",
        "userMessagingService",
        "customersService",
        "messagePreviewService",
        "$uibModal"
    ]

    function DeviceMessageBoardController(
        $rootScope,
        $scope,
        $state, // Used in HTML
        $stateParams,
        $timeout,
        imagesService,
        devicesService,
        messageBoardsService,
        speedLimitTrailersService,
        telemetryService,
        userMessagingService,
        customersService,
        messagePreviewService,
        $uibModal
    ){
        "use strict"

        document.body.scrollTop = document.documentElement.scrollTop = 0

        $rootScope.title = "Message Board Details | WANCO"

        $scope.loading         = true
        $scope.details_tab     = "details"
        $scope.deviceSummaries = []
        $scope.messageBoard    = {}
        $scope.customer        = {}
        $scope.bearingName     = "Unknown"
        $scope.editUnits       = false
        $scope.isSettingUnits  = false
        $scope.isRequesting    = false

        $scope.isBlankingMessageBoard = false

        $scope.previewController   = undefined
        $scope.willGeneratePreview = false

        $scope.optionsAutoRefreshIntervalNames   = ["None", "5 Hours", "1 Day", "3 Days", "1 Week"]
        $scope.optionsAutoRefreshIntervalSeconds = [ 0,      18000,     86400,   259200,   604800]
        $scope.currentAutoRefreshIntervalName    = $scope.optionsAutoRefreshIntervalNames[0]
        $scope.currentAutoRefreshIntervalSeconds = $scope.optionsAutoRefreshIntervalSeconds[0]
        $scope.nextAutoRefreshTime               = undefined
        $scope.isUpdatingAutoRefreshInterval     = false

        $scope.options = [
            {
              name:  "MPH",
              value: "MPH"
            },
            {
              name:  "KPH",
              value: "KPH"
            }
        ]

        $scope.selectedOption = $scope.options[0]

        const generatePreview = async () => {

            if (!$scope.messageBoard.hasOwnProperty("messageMulti")) {
                $scope.willGeneratePreview = false
                return
            }

            $scope.willGeneratePreview = true

            $scope.previewController = await messagePreviewService.getController($scope.messageBoard)
            messagePreviewService.generatePreviewFromMulti($scope.previewController, $scope.messageBoard.messageMulti, "previewContainerActive")

        }

        const getAutoRefreshIntervalSeconds = (interval_name) => {
            const idx = $scope.optionsAutoRefreshIntervalNames.indexOf(interval_name)
            if (idx >= 0 && $scope.optionsAutoRefreshIntervalSeconds.length > idx) {
                return $scope.optionsAutoRefreshIntervalSeconds[idx]
            }
            return $scope.optionsAutoRefreshIntervalSeconds[0]
        }

        const getAutoRefreshIntervalName = (interval_seconds) => {
            const idx = $scope.optionsAutoRefreshIntervalSeconds.indexOf(Number(interval_seconds))
            if (idx >= 0 && $scope.optionsAutoRefreshIntervalNames.length > idx) {
                return $scope.optionsAutoRefreshIntervalNames[idx]
            }
            return $scope.optionsAutoRefreshIntervalNames[0]
        }

        const updateDisplay = () => {
            if ($scope.messageBoard.telemetry.hasOwnProperty("voltage_battery")) {
                $scope.battery_health = telemetryService.getBatteryHealth($scope.messageBoard.telemetry.voltage_battery)
            }
            if ($scope.messageBoard.telemetry.hasOwnProperty("bearing") && $scope.messageBoard.telemetry.bearing !== undefined && $scope.messageBoard.telemetry.bearing.hasOwnProperty("degrees")) {
                $scope.bearingName = $rootScope.getBearingName($scope.messageBoard.telemetry.bearing.degrees)
            }
            if ($scope.messageBoard.meta.isWzOutput) {
                $scope.currentAutoRefreshIntervalName    = "None"
                $scope.currentAutoRefreshIntervalSeconds = 0
                $scope.nextAutoRefreshTime               = undefined
            } else if ($scope.messageBoard.telemetry.hasOwnProperty("auto_refresh") && $scope.messageBoard.telemetry.auto_refresh.hasOwnProperty("interval_seconds") && $scope.messageBoard.telemetry.auto_refresh.hasOwnProperty("next_refresh")) {
                $scope.currentAutoRefreshIntervalName    = getAutoRefreshIntervalName($scope.messageBoard.telemetry.auto_refresh.interval_seconds)
                $scope.currentAutoRefreshIntervalSeconds = getAutoRefreshIntervalSeconds($scope.currentAutoRefreshIntervalName)
                $scope.nextAutoRefreshTime               = moment($scope.messageBoard.telemetry.auto_refresh.next_refresh).tz($scope.messageBoard.device.timezone_iana).format("MMMM Do, HH:mm z")
            }



            if ($scope.messageBoard.meta.isMessageBoardSpeedLimitTrailer) {

                $scope.beaconsImageURL = imagesService.getBeaconsImage($scope.messageBoard)

                if ($scope.messageBoard.meta.isWvsl2) {
                    // WVSL2: pull speed from wvsl2.speed_display
                    var wvsl2Display = ($scope.messageBoard.wvsl2 && $scope.messageBoard.wvsl2.speed_display) || {}
                    var speed = wvsl2Display.speed;

                    if (speed === null || speed === undefined) {
                        $scope.digit2 = null;
                        $scope.digit3 = null;
                    } else if (speed < 10) {
                        $scope.digit2 = null;
                        $scope.digit3 = speed;
                    } else {
                        $scope.digit2 = Math.floor(speed / 10);
                        $scope.digit3 = speed % 10;
                    }
                    var fontType = ($scope.messageBoard.wvsl2 && $scope.messageBoard.wvsl2.speed_display &&
                        $scope.messageBoard.wvsl2.speed_display.font_type);
                    $scope.activeFontType = (fontType === 2) ? 'ohio' : 'standard';
                } else {
                    // Legacy WVSL1: uses speed_limit_display
                    $scope.speedImageURL = imagesService.getDisplayImage($scope.messageBoard)
                    let speed = $scope.messageBoard.speed_limit_display.speed;

                    if (speed === 0 || speed === null || speed === undefined) {
                        $scope.digit2 = null;
                        $scope.digit3 = 0;
                    } else if (speed < 10) {
                        $scope.digit2 = null;
                        $scope.digit3 = speed;
                    } else {
                        $scope.digit2 = Math.floor(speed / 10);
                        $scope.digit3 = speed % 10;
                    }

                    if ($scope.messageBoard.meta.isOhioHardware) {
                        $scope.activeFontType = 'ohio';
                    } else {
                        $scope.activeFontType = 'standard';
                    }

                    if ($scope.messageBoard.speed_limit_display.hasOwnProperty("units")) {
                        if ($scope.messageBoard.speed_limit_display.units === $scope.options[0].name) {
                            $scope.selectedOption = $scope.options[0]
                        } else {
                            $scope.selectedOption = $scope.options[1]
                        }
                    }
                }
            }

            $scope.editUnits = false
            $scope.isSettingUnits = false


        }

        let dataRetrieve = []
        const gotData = async () => {

            if (dataRetrieve.indexOf(false) === -1) {

                $scope.retrievedMessageBoard = true
                updateDisplay()
                // $scope.getCustomer($scope.messageBoard.device.customer_id)
                if ($scope.loading) {
                    $scope.loading = false
                    // Have the Generate the Preview here because loading = true before we get the Customer
                    await generatePreview()
                }
            }
        }

        dataRetrieve.push(false)
        devicesService.getDeviceSummaries((deviceSummaries) => {

            const summaries = []

            for (const device of deviceSummaries) {
                if (device !== null && device !== undefined) {
                    summaries.push(device)
                }
            }

            $scope.deviceSummaries = summaries

            dataRetrieve[dataRetrieve.indexOf(false)] = true
            gotData()

        })

        dataRetrieve.push(false)
        messageBoardsService.getMessageBoard($stateParams.message_board_id, async (data) => {

            $scope.messageBoard = data
            // Check if backend processing is in progress

            $rootScope.isWancoDevice = $scope.messageBoard.meta.isWancoDevice
            $rootScope.messageBoardName = data.name

            dataRetrieve[dataRetrieve.indexOf(false)] = true
            gotData()

        })

        $scope.setAutoRefreshInterval = (newAutoRefreshInterval) => {

            if ($scope.messageBoard.meta.isWzOutput) {
                userMessagingService.error("Message Board is Read Only")
                return
            }

            // Only update auto refresh interval if new value is different from current value
            if ($scope.currentAutoRefreshIntervalName !== newAutoRefreshInterval) {

                $scope.isUpdatingAutoRefreshInterval = true

                const success = (data) => {
                    $scope.isUpdatingAutoRefreshInterval = false
                    $scope.messageBoard.telemetry.auto_refresh = data
                    updateDisplay()
                }

                const failure = (error) => {
                    $scope.isUpdatingAutoRefreshInterval = false
                    userMessagingService.error(error)
                }

                messageBoardsService.setRefreshTimeInterval($stateParams.message_board_id, getAutoRefreshIntervalSeconds(newAutoRefreshInterval), success, failure)
            }
        }

        /**
            Refresh message board telemetry
         **/
        $scope.refreshMessageBoardTelemetry = () => {
            if (!$scope.isRequesting) {
                $scope.setRequesting(true)

                telemetryService.refreshTelemetry(
                    "MessageBoard",
                    $stateParams.message_board_id,
                    () => {
                    },
                    (error) => {
                        if (error.status !== 409) {
                            $scope.setRequesting(false)
                            $scope.messageBoard.in_process = false
                            userMessagingService.error(error)
                        }
                        else { // Show "background operation in place warning" in index.html
                            userMessagingService.info("There is a background operation in progress, please wait.")
                        }
                    }
                )
            }
        }

        /**
            Set Speed Display Modal
         **/
        $scope.openSetSpeedDisplayModal = () => {

            $uibModal.open({
                templateUrl: "app/modals/set-speed-display.view.html",
                controller: "SetSpeedDisplayModalController",
                resolve: {
                    options: () => {
                        return {
                            deviceID:       $scope.messageBoard.device.id,
                            messageBoardID: $stateParams.message_board_id,
                            baseImageURL:   $scope.messageBoard.speed_limit_display.base_image_url,
                            enableBeacons:  $scope.messageBoard.beacons.available,
                            startDisplaySettings: {
                                speed:              $scope.messageBoard.speed_limit_display.speed,
                                units:              $scope.messageBoard.speed_limit_display.units,
                                white_on_black:     $scope.messageBoard.speed_limit_display.white_on_black,
                                allow_style_change: $scope.messageBoard.speed_limit_display.allow_style_change,
                                beacons:            $scope.messageBoard.speed_limit_display.beacons
                            }
                        }
                    }
                }
            }).result.catch((res) => {
                if (!(res === "cancel" || res === "escape key press")) {
                    throw res
                }
            })
        }

        $scope.openSetSpeedDisplay5x7Modal = () => {

            $uibModal.open({
                templateUrl: "app/modals/set-speed-display.view-5x7.html",
                controller: "SetSpeedDisplay5x7ModalController",
                resolve: {
                    options: () => {
                        var wvsl2Display = ($scope.messageBoard.wvsl2 && $scope.messageBoard.wvsl2.speed_display) || {}
                        return {
                            deviceID:       $scope.messageBoard.device.id,
                            messageBoardID: $stateParams.message_board_id,
                            baseImageURL:   $scope.messageBoard.wvsl2.speed_display.base_image_url,
                            enableBeacons:  $scope.messageBoard.beacons.available,
                            startDisplaySettings: {
                                speed:              wvsl2Display.speed || 5,
                                units:              wvsl2Display.units || "MPH",
                                white_on_black:     wvsl2Display.white_on_black !== undefined ? wvsl2Display.white_on_black: true,
                                allow_style_change: wvsl2Display.allow_style_change !== undefined ? wvsl2Display.allow_style_change : true,
                                beacons:            wvsl2Display.beacons || false,
                                font_type:          wvsl2Display.font_type || 1
                            }
                        }
                    }
                }
            }).result.catch((res) => {
                if (!(res === "cancel" || res === "escape key press")) {
                    throw res
                }
            })
        }

        /**
           Open Set Unit Modal
         **/
        $scope.openSetUnitModal = (selectedOption) => {
            $uibModal.open({
                templateUrl: "app/modals/set-unit-modal.view.html",
                controller: "SetUnitModalController",
                resolve: {
                    messageBoardID: () => {
                        return $stateParams.message_board_id
                    },
                    selectedUnits: () => {
                        return selectedOption.value
                    },
                    currentSpeed: () => {
                        return $scope.messageBoard.speed_limit_display.speed
                    },
                    currentBeaconState: () => {
                        return $scope.messageBoard.speed_limit_display.beacons
                    },
                    currentWhiteOnBlack: () => {
                        return $scope.messageBoard.speed_limit_display.white_on_black
                    },
                    setSuccess: () => {
                        return (data) => {
                            $scope.messageBoard.speed_limit_display.units = data.measurement
                            userMessagingService.success("Set Units Request Successful")
                            updateDisplay()
                        }
                    },
                    setFailure: () => {
                        return () => {
                            userMessagingService.error("Set Units Request Failed")
                            updateDisplay()
                        }
                    }
                }
            }).result.catch((res) => {
                if (!(res === "cancel" || res === "escape key press")) {
                    throw res
                }
            }).then((value) => {
                if(value === undefined || value !== "cancel"){
                    $scope.isSettingUnits = true
                }

                $scope.editUnits = false
            })
        }

        $scope.setEditUnits = (value) => {
            $scope.editUnits = value
        }

        $scope.setRequesting = (value) => {
            $scope.isRequesting = value
        }

        /**
            Blank the message board
         **/
        $scope.blankMessageBoard = () => {

            if ($scope.messageBoard.meta.isWzOutput) {
                userMessagingService.error("Message Board is Read Only")
                return
            }

            if ($scope.isBlankingMessageBoard === false) {

                $scope.isBlankingMessageBoard = true

                const success = () => {
                    if ($scope.messageBoard.meta.isMessageBoardSpeedLimitTrailer && !$scope.messageBoard.meta.isWvsl2)
                        gtag("event", "display_change", { action: "complete", device_id: $scope.messageBoard.device.id, speed: 0 })
                    else
                        gtag("event", "display_change", { action: "complete", device_id: $scope.messageBoard.device.id, slot_name: "B001" })
                }

                const failure = (error) => {
                    $scope.isBlankingMessageBoard = false
                    userMessagingService.error(error)
                }

                if ($scope.messageBoard.meta.isMessageBoardSpeedLimitTrailer && !$scope.messageBoard.meta.isWvsl2) {

                    let blankData = {
                        speed:          0,
                        units:          $scope.messageBoard.speed_limit_display.units,
                        white_on_black: $scope.messageBoard.speed_limit_display.white_on_black,
                        beacons:        false
                    }

                    speedLimitTrailersService.setSpeedDisplay($stateParams.message_board_id, blankData, success, failure)

                } else {

                    messageBoardsService.blankMessageBoardDisplay($stateParams.message_board_id, success, failure)
                }
            }
        }

        $scope.openNewMessageText = () => {

            let template   = "app/components/messages/create-text.view.html"
            let controller = "MessageCreateController"

            if ($scope.messageBoard.meta.useV2Messaging) {
                template   = "app/components/messages/create-text-v2.view.html"
                controller = "MessageCreateV2Controller"
            }

            $uibModal.open({
                templateUrl: template,
                controller: controller,
                backdrop: "static",
                keyboard: false,
                windowClass: "createTextModal",
                resolve: {
                    messageBoard: () => {
                        return $scope.messageBoard
                    },
                    messageBoardIDs: () => {
                        return [$scope.messageBoard.id]
                    }
                }
            }).result.then(() => {
                $scope.messageBoard.in_process = true
            }).catch((res) => {
                if (!(res === "cancel" || res === "escape key press")) {
                    throw res
                }
            })

                // $(document).on('show.bs.modal', () => {
                //     previousScrollY = window.scrollY;
                //     $('body').addClass('modal-open').css({
                //         marginTop: -previousScrollY,
                //         overflow: 'hidden',
                //         left: 0,
                //         right: 0,
                //         top: 0,
                //         bottom: 0,
                //         position: 'fixed',
                //         backgroundColor: "red"
                //     });
                // }).on('hidden.bs.modal', () => {
                //     $('body').removeClass('modal-open').css({
                //         marginTop: 0,
                //         overflow: 'visible',
                //         left: 'auto',
                //         right: 'auto',
                //         top: 'auto',
                //         bottom: 'auto',
                //         position: 'static',
                //         backgroundColor: "white"
                //     });
                //     window.scrollTo(0, previousScrollY);
                // });
        }

        $scope.openNewMessageGraphic = () => {

            $uibModal.open({
                templateUrl: "app/components/messages/create-graphic.view.html",
                controller: "MessageCreateGraphicController",
                backdrop: "static",
                keyboard: false,
                windowClass: "createTextModal",
                resolve: {
                    messageBoard: () => {
                        return $scope.messageBoard
                    }
                }
            }).result.then(() => {
                $scope.messageBoard.in_process = true
            }).catch((res) => {
                if (!(res === "cancel" || res === "escape key press")) {
                    throw res
                }
            })
        }

        $scope.$on('$destroy', () => {
            userMessagingService.dismissInfo()

            if ($scope.previewController) {
                $scope.previewController.dispose()
            }
        })

        $scope.$watch("$root.pushedData", async (pushedData) => {

            if ($scope.messageBoard.hasOwnProperty("device")) {
                if (pushedData.device.hasOwnProperty("device")) {

                    if (pushedData.device.device.id === $scope.messageBoard.device.id) {

                        if (!pushedData.inProcess) {
                            $scope.messageBoard.in_process = pushedData.inProcess
                            $scope.setRequesting(false)
                            userMessagingService.dismissInfo()
                        }

                        $scope.isBlankingMessageBoard = false

                        const wasUserOwned = $scope.messageBoard.device.user_owned ? true : false
                        $scope.messageBoard = pushedData.device
                        $scope.messageBoard.device.user_owned = wasUserOwned
                        await generatePreview()

                        updateDisplay()

                        $timeout(() => {

                            // Inside Timeout because async/await prevents userMessagingService from performing (for some unknown reason)

                            if (pushedData.hasOwnProperty("success")) {

                                userMessagingService.success(pushedData.success)

                            } else if (pushedData.hasOwnProperty("error")) {

                                userMessagingService.error(pushedData.error)

                            }
                        }, 1)
                    }

                } else if (pushedData.hasOwnProperty("deviceID")) {
                    if (pushedData.deviceID === $scope.messageBoard.device.id) {

                        if (!pushedData.inProcess) {
                            $scope.setRequesting(false)
                            $scope.messageBoard.in_process = pushedData.inProcess
                            userMessagingService.dismissInfo()
                        }

                        $scope.isBlankingMessageBoard = false


                        if (pushedData.hasOwnProperty("success")) {

                            userMessagingService.success(pushedData.success)

                        } else if (pushedData.hasOwnProperty("error")) {

                            userMessagingService.error(pushedData.error)

                        }
                    }
                }
            }
        })

        // Watch the speed value. When it changes (from the modal), update the digits.
        if (!$scope.activeFontType) {
            $scope.activeFontType = 'standard';
        }

        // This "Watcher" ensures the main board updates when the modal saves
        $scope.$watch(function() {
            if ($scope.messageBoard.meta && $scope.messageBoard.meta.isWvsl2) {
                return $scope.messageBoard.meta && $scope.messageBoard.speed_display && $scope.messageBoard.wvsl2.speed_display.speed;
            }
            return $scope.messageBoard.speed_limit_display && $scope.messageBoard.speed_limit_display.speed;
        }, function (newVal){
            if (newVal !== undefined && newVal !== null) {

                // This splits "25" into "2" and "5" for the two <light-board> tags
                const speedStr = newVal.toString().padStart(2, '0');
                $scope.digit2 = speedStr[0]; // Tens
                $scope.digit3 = speedStr[1]; // Ones
            }
        }, true);


    }
})()
